import {
  getUserCompanyLimit,
  updateUserCompanyLimits,
} from '@simplywallst/services';
import { withAuth } from '@/utilities/queries';
import { getAuthCookie } from '@utilities/cookies';

export const mutateCompanyViews = async (companyId?: string) => {
  if (typeof companyId === 'undefined') return undefined;
  const hasCookie = await getAuthCookie();
  if (typeof hasCookie === 'undefined') {
    return undefined;
  }
  const limits = await withAuth(updateUserCompanyLimits, companyId);
  return limits.data;
};

export const getQueryKey = (id: string) => ['USER_COMPANY_LIMITS', id] as const;
export async function queryCompanyViews() {
  const response = await withAuth(getUserCompanyLimit);
  return response.data;
}

export type CompanyLimitResponse = Awaited<
  ReturnType<typeof queryCompanyViews>
>;
